import styled from "styled-components";
import { CardFrame, FullLine, GreySpace, WhiteSpace } from "../styles/styles";
import { CardHeadLine } from "../Molecules/Settings/CardHeadLine";
import { useTranslation } from "@coworker/locales";
import { Media } from "../types/media";
import { MediaTypes } from "../constants";
import { getMediaTypeText, getSelectableMediaTypes } from "../tools";
import { ActiveSwitcher } from "../Molecules/Settings/ActiveSwitcher";
import { AboutSection } from "./Settings/Sections/AboutSection";
import { LocationAndSizeSection } from "./Settings/Sections/LocationAndSizeSection";
import { DeleteSection } from "./Settings/Sections/DeleteSection";
import { RadioButtonWithInput } from "../Molecules/Settings/RadioButtonWithInput";

const GreyBackground = styled("div")`
  background-color: var(--grey100);
  width: calc(100%);
  height: calc(100%);
`;
interface MediaSettingsFormProps {
  currentMedia: Media;
  medias: Media[];
  setCurrentMedia: (newMedia: Media) => void;
  currentCheckedMediaType: MediaTypes;
  setCurrentCheckedMediaType: (newMediaType: MediaTypes) => void;
  isUpdate: boolean;
}

export function MediaSettingsForm({
  currentMedia,
  medias,
  setCurrentMedia,
  currentCheckedMediaType,
  setCurrentCheckedMediaType,
  isUpdate,
}: MediaSettingsFormProps) {
  const { t } = useTranslation();
  const radioButtonWithInput = (mediaType: MediaTypes, key?: string) => (
    <RadioButtonWithInput
      key={key}
      media={currentMedia}
      medias={medias}
      mediaType={mediaType}
      currentCheckedMediaType={currentCheckedMediaType}
      onSave={(newMedia) => setCurrentMedia(newMedia)}
      onChange={() => {
        setCurrentMedia({ ...currentMedia, mediaType: mediaType });
        setCurrentCheckedMediaType(mediaType);
      }}
    />
  );

  return (
    <GreyBackground>
      <CardFrame>
        <GreySpace />
        <CardHeadLine
          character={"1"}
          headline={t("selectMediaTypeString")}
          subHeadline={t("mandatoryString")}
        />
        <WhiteSpace height="10" />
        {currentMedia.mediaType !== MediaTypes.ROOM ? (
          <>
            {!(isUpdate && currentMedia.mediaType === MediaTypes.HOME) ? (
              <>
                {getSelectableMediaTypes(isUpdate ? [MediaTypes.HOME] : []).map(
                  (mediaType) => radioButtonWithInput(mediaType, mediaType)
                )}
              </>
            ) : (
              <>{radioButtonWithInput(MediaTypes.HOME)}</>
            )}
          </>
        ) : (
          <>{radioButtonWithInput(MediaTypes.ROOM)}</>
        )}
      </CardFrame>
      <GreySpace />
      <CardFrame>
        <CardHeadLine
          character={"#"}
          headline={t(`statusOfString`, {
            name: getMediaTypeText(currentMedia.mediaType as MediaTypes),
          })}
        />
        <FullLine />
        <ActiveSwitcher
          media={currentMedia}
          onSave={(newMedia) => setCurrentMedia(newMedia)}
        />
        <WhiteSpace height={"12"} />
      </CardFrame>
      <GreySpace />
      <AboutSection
        media={currentMedia}
        onSave={(newMedia) => setCurrentMedia(newMedia)}
      />
      <GreySpace />
      <LocationAndSizeSection
        media={currentMedia}
        onSave={(newMedia) => setCurrentMedia(newMedia)}
      />
      <GreySpace />
      {isUpdate && <DeleteSection currentMedia={currentMedia} />}
      <GreySpace />
    </GreyBackground>
  );
}
